// extracted by mini-css-extract-plugin
module.exports = {"main__wrapper":"main_main__wrapper__2Bn1t"};